<template>
    <div class="or-admin-textarea">
        <p class="title" :style="{color: white_color ? 'white' : null}">{{options.title}}</p>
        <textarea class="textarea" v-model="options.value" @keyup="unsaved"></textarea>
    </div>
</template>

<script>
export default {
    props: {
        options: Object,
        white_color: Boolean
    },
    methods: {
        unsaved() {
            this.$emit('unsaved');
        }
    }
}
</script>

<style scoped>
    .or-admin-text-textarea {
        position: relative;
        width: 740px;
    }
    .title {
        font-size: 14px;
        line-height: 16px;
        color: black;
        text-align: left;
        margin-left: 15px;
        margin-bottom: 5px;
    }
    .textarea {
        font-family: Roboto;
        font-size: 14px;
        line-height: 16px;
        width: 100%;
        min-height: 50px;
        height: 50px;
        max-height: 1000px;
        resize: vertical;
        border-radius: 8px;
        outline: none;
        border: #979797 1px solid;
        padding: 17px 16px 14px 16px;
        box-sizing: border-box;
    }
</style>